import { useState, useEffect, useCallback } from 'react';
import { fetchUninvoicedBonliv, fetchDashboardSummary } from '../models/businessInsightsAPI';

// Hook for fetching uninvoiced bonliv
export const useUninvoicedBonliv = (days = 7) => {
  const [data, setData] = useState({ items: [], summary: {}, byClient: [] });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    fetchUninvoicedBonliv(days)
      .then(response => {
        setData(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, [days]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch };
};

// Hook for dashboard summary
export const useDashboardSummary = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const refetch = useCallback(() => {
    setLoading(true);
    fetchDashboardSummary()
      .then(response => {
        setData(response.data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch };
};






